'use strict';

angular.module('shiftTraderApp')
  .controller('CreateTradeCtrl', function ($scope, $rootScope, $timeout, $filter, $location, ShiftTradesResource, Users, SAErrorHandler, workPeriod, tradeWorkPeriod, me, mode) {
    $scope.me = me;
    $scope.workPeriod = workPeriod;
    $scope.tradeWorkPeriod = tradeWorkPeriod;
    $scope.mode = mode;

    if (!_.isArray($scope.tradeWorkPeriod)) {
      $rootScope.$broadcast('setTopNavTitle', 'Review Trade');
    } else {
      $rootScope.$broadcast('setTopNavTitle', 'Review Giveaway');
    }

    var abbreviatedName = $filter('abbreviatedName');
    $scope.tradeHeaderMessage = (function() {
      if ($scope.mode === 'trade') {
        return 'Your Trade With ' + abbreviatedName($scope.tradeWorkPeriod.user.name);
      } else {
        return 'Your Giveaway';
      }
    }());

    $scope.state = {
      requestSent: false,
      requestSuccess: false
    };


    $scope.createGiveaway = function() {
      if (!$scope.state.requestSent) {
        $scope.state.requestSent = true;

        var giveaway = {
          user_id: workPeriod.user.id,
          work_period_id: workPeriod.id,
          message: '',
          organization_id: workPeriod.organization.id
        };
        ShiftTradesResource.save({}, giveaway, function(createdGiveAway) {
          console.log('Yeah, we created it!');
          console.log(createdGiveAway);

          if (_.has(createdGiveAway, 'id')) {
            $scope.state.requestSuccess = true;
            $location.path('trades/' + createdGiveAway.id);
          }
        }, function(response) {
          $scope.state.requestSent = false;
          $scope.state.requestSuccess = false;
          SAErrorHandler.processError(response);
        });
      }
    };

    $scope.createTrade = function () {
      if (!$scope.state.requestSent) {
        $scope.state.requestSent = true;

        var trade = {
          user_id: $scope.workPeriod.user.id,
          work_period_id: $scope.workPeriod.id,
          message: '',
          trade_work_period_id: $scope.tradeWorkPeriod.id,
          trade_user_id: $scope.tradeWorkPeriod.user.id,
          organization_id: $scope.workPeriod.organization.id
        };

        ShiftTradesResource.save({}, trade, function (createdTrade) {
          console.log('Yeah, we created it!');
          console.log(createdTrade);

          if (_.has(createdTrade, 'id')) {
            $scope.state.requestSuccess = true;
            $location.path('trades/' + createdTrade.id);
          }
        }, function(response) {
          $scope.state.requestSent = false;
          $scope.state.requestSuccess = false;
          SAErrorHandler.processError(response);
        });
      }
    };
  });
